<script>
    import { onMount } from 'svelte';
    import PasswordValidator from '../components/PasswordValidator.svelte';
    import AuthService from '../services/auth.service.js';
    import Swal from "sweetalert2";
    import Loader from '../components/Loader.svelte';

    export let params;

    let newPassword = '', error = '', loading = false, token = '';

    let validPassword = {
        dirty: false,
        valid: true,
        errors: []
    }

    onMount(() => {
        token = params ? params.token : null;
        verifyToken();
    });

    async function verifyToken() {
        if (loading) return;
        loading = true;
        const url = `/reset_password/verify/${token}`;

        AuthService
            .verifyResetPasswordToken(url)
            .then((response) => {
                response = response ? response.data : null;
                if (!response.data || response.data.error) {
                    error = response.data.error;
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error,
                        confirmButtonText: 'Go to login',
                    }).then((result) => {
                        window.location = '/login?v=' + Date.now();
                    })
                }
            })
            .catch((e, data) => {
                error = (e || 'ERROR:UNKNOWN').toString();
                if (e && e.response && e.response.data && e.response.data.error) {
                    error = e.response.data.error;
                }
            })
            .finally(() => {
                setTimeout(() => loading = false, 1000);
            });
    }

    async function doResetPassword() {
        error = '';
        loading = true;

        AuthService
            .resetPassword({password: newPassword, token})
            .then((response) => {
                response = response ? response.data : null;
                if (!response.data || response.data.error) {
                    error = response.data.error;
                } else {
                    Swal.fire({
                        icon: 'success',
                        title: 'Correct',
                        text: 'Password updated',
                        confirmButtonText: 'Go to login',
                    }).then((result) => {
                        window.location = '/login?v=' + Date.now();
                    })
                }
            })
            .catch((e, data) => {
                error = (e || 'ERROR:UNKNOWN').toString();
                if (e && e.response && e.response.data && e.response.data.error) {
                    error = e.response.data.error;
                }
            })
            .finally(() => {
                setTimeout(() => loading = false, 1000);
            });
    }

    function passwordChanged(password) {
        newPassword = password;
    }
</script>
<main class="pt-3 container">
    {#if loading}
        <Loader fixed={true}></Loader>
    {:else}
        <div class="row">
            <form
                class="col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-4 offset-lg-4"
                on:submit|preventDefault="{doResetPassword}">
                <fieldset>
                    <legend class="pt-5 pb-2 text-center">
                        <img src="/img/Riverside-logo-full.gif">
                    </legend>
                    <h5 class="my-2">Reset password</h5>
                    <PasswordValidator confirmPassword={true} isResetPassword={true}
                        bind:validPassword={validPassword} on:change={(e) => passwordChanged(e.detail.value)} />

                    {#if error && !loading}
                        <output class="alert alert-danger d-block">
                            <strong>ERROR:</strong> {error}
                        </output>
                    {/if}
                    <div class="pt-2">
                        <button class="btn btn-primary" type="submit" disabled="{loading}">Update</button>
                    </div>
                </fieldset>
            </form>
        </div>
    {/if}
</main>
